module.exports = __webpack_public_path__ + "img/twig_map_marker.4b6b8aaa.png";